import { Button } from "@mui/material";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { toggleIncidentReportingDepartmentDialog } from "../../../../app/slices/VarianceModuleSlice";
import { VarianceInitiateIndividualType } from "./visitor/VarianceInitiateIndividualType";
import { useParams } from "react-router";
import { ReduxUpdate } from "../../../../utils/ReduxUpdateCommands";
import { editVariance } from "../../../../services/varianceService/model/varianceRequest/VarianceRequestSlice";
import { useMyProfileQuery } from "../../../../services/profileService/profile-api";
import { VarianceInitiatePatientSearchDialog } from "./patient/VarianceInitiatePatientSearchDialog";
import { VarianceInitiateIdentification } from "./visitor/VarianceInitiateIndividual";
import { ReportingDepartment } from "./reportingDepartment/ReportingDepartment";
import { PermissionChecker } from "../../../../services/varianceService/util/PermissionChecker";

function VarianceInitiate() {
  const { center } = useParams();
  const incident = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );
  const dispatch = useAppDispatch();
  dispatch(editVariance(new ReduxUpdate("center", center!)));
  const { data } = useMyProfileQuery();
  
  React.useEffect(() => {
    if (data && data.upn) {
      dispatch(editVariance(new ReduxUpdate("createdBy", data.upn)));
    }
  }, [data, dispatch]);
  
  const canEdit = (): boolean => {
    return PermissionChecker.canEditVariance(data, incident);
  };

  return (
    <React.Fragment>
      {canEdit() && (
        <Button
          variant="contained"
          sx={{ background: "#62BCBD" }}
          onClick={() => dispatch(toggleIncidentReportingDepartmentDialog())}
        >
          Create Incident
        </Button>
      )}
      <ReportingDepartment />
      <VarianceInitiateIndividualType />
      <VarianceInitiatePatientSearchDialog />
      <VarianceInitiateIdentification />
    </React.Fragment>
  );
}
export { VarianceInitiate };
